<template>
  <v-container class="fill-height" fluid style="padding: 0">
    <v-row justify="center">
      <v-col cols="3"></v-col>
      <v-col cols="6" style="padding-bottom: 0px;">
        <v-row justify="center" style="height: 60px"></v-row>

        <p class="display-1" style="text-align: center;">Production Ready JDK for Cloud!</p>
        <p class="font-weight-light" style="text-align: center;">
          Over the years, more than a billion lines of Java code have been written in Alibaba.
          While adopting OpenJDK to run these applications, we have found a need to customize it
          specifically for large-scale Java application deployments. Our customization has been
          well tested in our environment. We are now contributing some of our work into the Java community.
        </p>
        <p class="font-weight-light" style="text-align: center;">
          Alibaba Dragonwell, as a downstream version of OpenJDK, is the in-house OpenJDK implementation
          at Alibaba. It is optimized for online e-commerce, financial and logistics applications running
          on 100,000+ servers. Alibaba Dragonwell is the engine that runs these distributed Java applications
          in extreme scaling.
        </p>
      </v-col>
      <v-col cols="3"></v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="1"></v-col>
      <v-col cols="10" style="padding-top: 0px;">
        <v-row justify="center">
          <span>Download Now</span>
        </v-row>
        <v-row justify="center" style="padding-top: 16px;">
          <div class="select-group-item">
            <v-select v-model="type"
              :items="typeItems"
              item-text="text"
              item-value="value"
              item-disabled="disabled"
              label=""
              outlined
              color="#00000061"
              single-line
            ></v-select>
          </div>
          <div class="select-group-item">
            <v-select v-model="edition"
              :items="editionItems"
              item-text="text"
              item-value="value"
              item-disabled="disabled"
              label=""
              outlined
              color="#00000061"
              single-line
            ></v-select>
          </div>
          <div class="select-group-item">
            <v-select v-model="version"
              :items="versionItems"
              item-text="text"
              item-value="value"
              label=""
              outlined
              color="#00000061"
              persistent-hint
              single-line
            ></v-select>
          </div>
          <div class="select-group-item">
            <v-select v-model="arch"
              :items="archItems"
              item-text="text"
              item-value="value"
              label=""
              outlined
              color="#00000061"
              persistent-hint
              single-line
            ></v-select>
          </div>
          <div class="select-group-item">
            <v-select v-model="os"
              :items="osItems"
              item-text="text"
              item-value="value"
              item-disabled="disabled"
              label=""
              outlined
              color="#00000061"
              persistent-hint
              single-line
            ></v-select>
          </div>
        </v-row>


        <v-row class="mt-4" justify="center">
          <v-btn
              tile
              x-large
              color="red"
              dark
              :href="va2d[version][arch][os]"
              style="height: 72px; width: 240px; text-transform: none;">
            <v-icon class="mr-1">mdi-cloud-download</v-icon>
            {{ v2p[version].version }}
            <span class="ml-1 font-weight-light caption">{{ v2p[version].upstreamVersion }}</span>
          </v-btn>
        </v-row>
        <v-row class="mt-4" justify="center">
          <a
              style="color: black; text-decoration: none;"
              :href="v2p[version].releases"
              target="_blank"
          >Release Archive</a>
          <span class="ml-2 mr-2">|</span>
          <a
              style="color: black; text-decoration: none;"
              :href="v2p[version].changeLog"
              target="_blank"
          >Changelog</a>
          <span class="ml-2 mr-2">|</span>
          <a
              style="color: black; text-decoration: none;"
              :href="v2p[version].userGuide"
              target="_blank"
          >User Guide</a>
        </v-row>
      </v-col>
      <v-col cols="1"></v-col>
    </v-row>

    <v-img :src="require('../assets/circle_brown.png')" height="110px"/>
    <v-row style="background-color: #F1F1F1;padding-bottom: 30px;" justify="center">
      <h2>OPENJDK DOWNSTREAM</h2>
    </v-row>
    <v-row style="background-color: #F1F1F1;" justify="center" align="center">
      <v-col cols="2"></v-col>
      <v-col cols="2">
        <v-img :src="require('../assets/img/tea.svg')" style="margin-left: -24px;"/>
      </v-col>
      <v-col cols="6"
          style="font-size: 1.25em; line-height: 1.4em;">
          <p>
            Alibaba Dragonwell is a downstream version of OpenJDK and is a reliable alternative to OpenJDK in the production environment. Alibaba Dragonwell is available in two editions: 
          </p>
          <div class="edition-icon-divider">
            <div style="margin-left: 36px;">
              Standard Edition: OpenJDK upstream based and have more enhancements, including bug-fixing, security patches, tooling support, etc.
              <v-divider style="margin:12px 0;"></v-divider>
            </div>
          </div>
          <div class="edition-icon-divider">
            <div style="margin-left: 36px;">
              Extended Edition: everything in the standard edition, plus: extra customized/significant features optimized for the cloud and widely used in Alibaba's production environment. 
              <v-divider style="margin:12px 0;"></v-divider>
            </div>
          </div>
          <p>Both editions pass the Eclipse AQAvit quality assurance test suite to provide a stable and high-quality Java engine for your applications. </p>
          <p class="font-router-link" style="color: #1890ff;" @click="linkClick">
          Alibaba Dragonwell 8 Standard Edition has passed the Java SE 8 Compatibility Test Suite(JCK tests).
          </p>
      </v-col>
      <v-col cols="2"></v-col>
    </v-row>

    <v-img
        :src="require('../assets/circle_white.png')"
        height="110px"
        style="background-color: #F1F1F1"
    />
    <v-row justify="center">
      <h2>PRODUCTION READY &amp; SECURITY</h2>
    </v-row>
    <v-row>
      <v-row justify="center" align="center">
        <v-col cols="2"></v-col>
        <v-col style="font-size: 1.25em; line-height: 1.6em;" cols="4">
          Alibaba Dragonwell includes the latest bug-fixing and secutiry patches from upstream, and ships
          extra features widely used
          in Alibaba's production environment.
        </v-col>
        <v-col cols="1"></v-col>
        <v-col cols="2">
          <v-img :src="require('../assets/img/great_wall.svg')"/>
        </v-col>
        <v-col cols="3"></v-col>
      </v-row>
    </v-row>

    <v-img :src="require('../assets/circle_brown.png')" height="110px"/>
    <v-row style="background-color: #F1F1F1;" justify="center">
      <h2>PERFORMANCE</h2>
    </v-row>
    <v-row style="background-color: #F1F1F1;">
      <v-row justify="center" align="center">
        <v-col cols="2"></v-col>
        <v-col cols="2">
          <v-img :src="require('../assets/img/hopter.svg')"/>
        </v-col>
        <v-col cols="1"></v-col>
        <v-col style="font-size: 1.25em; line-height: 1.6em;" cols="4">
          As the engine of Alibaba's Java application,
          Dragonwell supports all Java businesses in Alibaba economy,
          accumulating a large number of practices and innovations in business scenarios.
        </v-col>
        <v-col cols="3"></v-col>
      </v-row>

      <v-row justify="center" align="center">
        <v-col cols="2"></v-col>
        <v-col cols="5">
          <vue-code-highlight language="java" style="width: 100%;">{{ javaCode }}</vue-code-highlight>
        </v-col>
        <v-col cols="3">
          <v-row style="font-size: 1.25em; line-height: 1.6em;">
            <span>Speed up the ping-pong test with Wisp2.</span>
          </v-row>
          <v-row>
            <vue-code-highlight language="bash" style="width: 100%;">{{ shellCode }}
            </vue-code-highlight>
          </v-row>
        </v-col>
        <v-col cols="2"></v-col>
      </v-row>

      <v-row justify="center" align="center">
        <v-col cols="2"></v-col>
        <v-col cols="4">
          <WispCI></WispCI>
        </v-col>
        <v-col cols="4" style="font-size: 1.25em; line-height: 1.6em;">
          <p>
            TechEmpower Web Framework Benchmarks(tfb) is an authoritative test set in the web server
            performance area.
          </p>
          <p>
            With the help of Wisp, most of the existing tfb benchmarks get performance improvement without
            any source code modification and only need to add a JVM parameter.
          </p>
          <p>
            The chart shows the comparison of the throughput between Dragonwell+Wisp
            and OpenJDK under <b>spring boot</b> framework. </p>
        </v-col>
        <v-col cols="2"></v-col>
      </v-row>
    </v-row>

    <v-img
        :src="require('../assets/circle_white.png')"
        height="110px"
        style="background-color: #F1F1F1"
    />
    <v-row justify="center">
      <h2>CLOUD NATIVE</h2>
    </v-row>
    <v-row justify="center" align="center">
      <v-col cols="3"></v-col>
      <v-col style="font-size: 1.25em; line-height: 1.6em;" cols="4">
        With the help of JWarmup and ElasticHeap, your application will consume
        less warm-up time and memory footprint.
      </v-col>
      <v-col cols="1"></v-col>
      <v-col cols="2">
        <v-img :src="require('../assets/img/cloud.svg')"/>
      </v-col>
      <v-col cols="2"></v-col>
    </v-row>

    <v-img :src="require('../assets/circle_brown.png')" height="110px"/>
    <v-row style="background-color: #F1F1F1;" justify="center">
      <h2>SERVICEABILITY</h2>
    </v-row>
    <v-row style="background-color: #F1F1F1;">
      <v-row justify="center" align="center">
        <v-col cols="2"></v-col>
        <v-col cols="2">
          <v-img :src="require('../assets/img/tool.svg')"/>
        </v-col>
        <v-col cols="1"></v-col>
        <v-col style="font-size: 1.25em; line-height: 1.6em;" cols="4">
          Integrated JFR, Java Mission Control and a
          series of practical monitoring &amp; troubleshooting tools.
        </v-col>
        <v-col cols="3"></v-col>
      </v-row>
    </v-row>
    <v-row class="footer">
      <v-col cols="2"></v-col>
      <v-col cols="3">
        <v-row>
          <v-col cols="5">
            <h4 class="mb-4">Related</h4>
            <a class="link" target="_blank" href="https://openanolis.org/">OpenAnolis</a>
          </v-col>
          <v-col cols="2"></v-col>
          <v-col cols="5">
            <h4 class="mb-4">Get Involved</h4>
            <a class="link" href="https://github.com/dragonwell-project/dragonwell8/issues/new/choose">Raise Issue</a>
            <a class="link"
               href="https://job.alibaba.com/zhaopin/position_detail.htm?positionCode=GP629427">Join Us</a>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="2"></v-col>
      <v-col cols="3">
        <v-row>
          <v-col cols="5">
            <v-row>
              <v-img :src="require('../assets/img/ding_qr.png')"></v-img>
            </v-row>
            <v-row>
              <span style="width: 100%" class="text-center">Dragonwell Dingtalk</span>
            </v-row>
          </v-col>
          <v-col cols="2"></v-col>
          <v-col cols="5">
            <v-row>
              <v-img :src="require('../assets/img/acn_qr.jpg')"></v-img>
            </v-row>
            <v-row>
              <span style="width: 100%" class="text-center">Alibaba cloud native</span>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="2">
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
import {component as VueCodeHighlight} from "vue-code-highlight";
// import "vue-code-highlight/themes/duotone-sea.css";
import "vue-code-highlight/themes/duotone-sea.css";
import "vue-code-highlight/themes/window.css";
import "prism-es6/components/prism-markup-templating";
import "prism-es6/components/prism-bash";
import "prism-es6/components/prism-java";
import WispCI from "./WispCI.vue";
import axios from "axios";

export default {
  components: {
    VueCodeHighlight,
    WispCI
  },
  props: {
    source: String
  },
  data() {
    return {
      timer1: null,
      timer2: null,
      typeItemsOrigin: [
        { text: 'China Mainland', value: 'oss' },
        { text: 'United States', value: 'github' },
      ],
      editionItemsOrigin: [
        { text: 'Extended Edition', value: 'Extended' },
        { text: 'Standard Edition', value: 'Standard' },
      ],
      versionItemsOrigin: [
        { text: 'Dragonwell 8', value: 'dw8' },
        { text: 'Dragonwell 11', value: 'dw11' },
        { text: 'Dragonwell 17', value: 'dw17' },
        { text: 'Dragonwell 21', value: 'dw21' },
      ],
      archItemsOrigin: [
        { text: 'x86_64', value: 'x86_64' },
        { text: 'aarch64', value: 'aarch64' },
      ],
      osItemsOrigin: [
        { text: 'linux', value: 'linux' },
        { text: 'alpine-linux', value: 'alpine-linux' },
        { text: 'windows', value: 'windows' },
      ],

      typeItems: [
        { text: 'China Mainland', value: 'oss' },
        { text: 'United States', value: 'github' },
      ],
      editionItems: [
        { text: 'Extended Edition', value: 'Extended' },
        { text: 'Standard Edition', value: 'Standard' },
      ],
      versionItems: [
        { text: 'Dragonwell 8', value: 'dw8' },
        { text: 'Dragonwell 11', value: 'dw11' },
        { text: 'Dragonwell 17', value: 'dw17' },
        { text: 'Dragonwell 21', value: 'dw21' },
      ],
      archItems: [
        { text: 'x86_64', value: 'x86_64' },
        { text: 'aarch64', value: 'aarch64' },
      ],
      osItems: [
        { text: 'linux', value: 'linux' },
        { text: 'alpine-linux', value: 'alpine-linux' },
        { text: 'windows', value: 'windows' },
      ],
      version: 'dw8',
      type: 'oss',
      edition: 'Extended',
      arch: 'x86_64',
      os: 'linux',
      windowsD: false,
      alpineD: true,
      release: [],
      v2p: { // version to product
        dw8: {
          version: '8.9.10',
          upstreamVersion: '',
          changeLog: 'https://github.com/dragonwell-project/dragonwell8/wiki/Alibaba-Dragonwell8-Extended-Edition-Release-Notes',
          userGuide: 'https://github.com/dragonwell-project/dragonwell8/wiki/Alibaba-Dragonwell8-User-Guide',
          releases: 'https://github.com/dragonwell-project/dragonwell8/wiki/%E4%B8%8B%E8%BD%BD%E9%95%9C%E5%83%8F(Mirrors-for-download)'
        },
        dw11: {
          version: '11.0.13.9',
          upstreamVersion: '',
          changeLog: 'https://github.com/dragonwell-project/dragonwell11/wiki/Alibaba-Dragonwell-11-Extended-Edition-Release-Notes',
          userGuide: 'https://github.com/dragonwell-project/dragonwell11/wiki/Alibaba-Dragonwell-11-User-Guide',
          releases: 'https://github.com/dragonwell-project/dragonwell11/wiki/%E4%B8%8B%E8%BD%BD%E9%95%9C%E5%83%8F(Mirrors-for-download)'
        },
        dw17: {
          version: '17.0.1.0.1+12',
          upstreamVersion: '',
          changeLog: 'https://github.com/dragonwell-project/dragonwell17/wiki/Alibaba-Dragonwell-17-Extended-Edition-Release-Notes',
          userGuide: 'https://github.com/dragonwell-project/dragonwell17/wiki/Alibaba-Dragonwell-17-User-Guide',
          releases: 'https://github.com/dragonwell-project/dragonwell17/wiki/%E4%B8%8B%E8%BD%BD%E9%95%9C%E5%83%8F(Mirrors-for-download)'
        },
        dw21: {
          version: '21.0.1.0.1+12',
          upstreamVersion: '',
          changeLog: 'https://github.com/dragonwell-project/dragonwell21/wiki/Alibaba-Dragonwell-21-Standard-Edition-Release-Notes',
          userGuide: 'https://github.com/dragonwell-project/dragonwell21/wiki/',
          releases: 'https://github.com/dragonwell-project/dragonwell21/wiki/Mirrors-for-download-(%E4%B8%8B%E8%BD%BD%E9%95%9C%E5%83%8F)'
        }
      },
      va2d: { // version & arch to download
        dw8: {
          x86_64: {
            linux: 'https://github.com/dragonwell-project/dragonwell8/releases/download/dragonwell-8.9.10_jdk8u312-ga/Alibaba_Dragonwell_8.9.10_x64_linux.tar.gz',
            windows: 'https://github.com/dragonwell-project/dragonwell8/releases/download/dragonwell-8.11.12_jdk8u332-ga/Alibaba_Dragonwell_8.11.12_x64_windows.zip'
          },
          aarch64: {
            linux: 'https://github.com/dragonwell-project/dragonwell8/releases/download/dragonwell-8.9.10_jdk8u312-ga/Alibaba_Dragonwell_8.9.10_aarch64_linux.tar.gz'
          }
        },
        dw11: {
          x86_64: {
            linux: 'https://github.com/dragonwell-project/dragonwell11/releases/download/dragonwell-11.0.12.7_jdk-11.0.12-ga/Alibaba_Dragonwell_11.0.12.7_x64_linux.tar.gz',
            "alpine-linux": 'https://github.com/dragonwell-project/dragonwell11/releases/download/dragonwell-11.0.12.7_jdk-11.0.12-ga/Alibaba_Dragonwell_11.0.12.7_x64_alpine-linux.tar.gz',
            windows: 'https://github.com/dragonwell-project/dragonwell11/releases/download/dragonwell-11.0.15.11_jdk-11.0.15-ga/Alibaba_Dragonwell_11.0.15.11.9_x64_windows.zip'
          },
          aarch64: {
            linux: "https://github.com/dragonwell-project/dragonwell11/releases/download/dragonwell-11.0.12.7_jdk-11.0.12-ga/Alibaba_Dragonwell_11.0.12.7_aarch64_linux.tar.gz"
          },
          "risc-v": {
            linux: "https://github.com/dragonwell-project/dragonwell11/releases/download/dragonwell-extended-11.0.18.14_jdk-11.0.18-ga/Alibaba_Dragonwell_Extended_11.0.18.14.9_aarch64_linux.tar.gz",
          },
        },
        dw17: {
          x86_64: {
            linux: 'https://github.com/dragonwell-project/dragonwell11/releases/download/dragonwell-11.0.12.7_jdk-11.0.12-ga/Alibaba_Dragonwell_11.0.12.7_x64_linux.tar.gz',
            "alpine-linux": 'https://github.com/dragonwell-project/dragonwell11/releases/download/dragonwell-11.0.12.7_jdk-11.0.12-ga/Alibaba_Dragonwell_11.0.12.7_x64_alpine-linux.tar.gz',
            windows: 'https://github.com/dragonwell-project/dragonwell17/releases/download/dragonwell-17.0.3.0.3%2B7_jdk-17.0.3-ga/Alibaba_Dragonwell_17.0.3.0.3+7_x64_windows.zip'
          },
          aarch64: {
            linux: "https://github.com/dragonwell-project/dragonwell11/releases/download/dragonwell-11.0.12.7_jdk-11.0.12-ga/Alibaba_Dragonwell_11.0.12.7_aarch64_linux.tar.gz"
          },
        },
        dw21: {
          x86_64: {
            linux: 'https://github.com/dragonwell-project/dragonwell21/releases/download/dragonwell-standard-21.0.1.0.1%2B12_jdk-21.0.1-ga/Alibaba_Dragonwell_Standard_21.0.1.0.1.12_x64_linux.tar.gz',
            "alpine-linux": 'https://github.com/dragonwell-project/dragonwell21/releases/download/dragonwell-standard-21.0.1.0.1%2B12_jdk-21.0.1-ga/Alibaba_Dragonwell_Standard_21.0.1.0.1.12_x64_alpine-linux.tar.gz',
            windows: 'https://github.com/dragonwell-project/dragonwell21/releases/download/dragonwell-standard-21.0.1.0.1%2B12_jdk-21.0.1-ga/Alibaba_Dragonwell_Standard_21.0.1.0.1.12_x64_windows.zip'
          },
          aarch64: {
            linux: 'https://github.com/dragonwell-project/dragonwell21/releases/download/dragonwell-standard-21.0.1.0.1%2B12_jdk-21.0.1-ga/Alibaba_Dragonwell_Standard_21.0.1.0.1.12_aarch64_linux.tar.gz'
          }
        }
      },
      shellCode: '$ java PingPong\n' +
          ' 12560 ms\n' +
          '\n' +
          ' $ java -XX:+UseWisp2 PingPong\n' +
          ' 1132 ms',
      javaCode: 'public static void main(String[] args) {\n' +
          '    BlockingQueue<> q1, q2; // = ...\n' +
          '    THREAD_POOL.submit(() -> pingpong(q2, q1));\n' +
          '    future = THREAD_POOL.submit(() -> pingpong(q1, q2));\n' +
          '    q1.put((byte) 1);\n' +
          '    System.out.println(future.get() + " ms");\n' +
          '}\n' +
          '\n' +
          'private static long pingpong(in, out) {\n' +
          '    long start = System.currentTimeMillis();\n' +
          '    for (int i = 0; i < 1_000_000; i++) \n        out.put(in.take());\n' +
          '    return System.currentTimeMillis() - start;\n' +
          '} '
    };
  },
  methods: {
    linkClick() {
      this.$router.push('/tck-affidavit')
    },
    getReleasesData() {
      axios.get("/releases.json").then(response => {
        this.release = response.data
        this.v2p.dw8.version = this.release[this.type][this.edition.toLowerCase()]["version8"]
        this.v2p.dw8.changeLog = 'https://github.com/dragonwell-project/dragonwell8/wiki/Alibaba-Dragonwell8-' + this.edition + '-Edition-Release-Notes'
        this.va2d.dw8.x86_64["linux"] = this.release[this.type][this.edition.toLowerCase()]["xurl8"]
        this.va2d.dw8.aarch64["linux"] = this.release[this.type][this.edition.toLowerCase()]["aurl8"]
        this.va2d.dw8.x86_64["windows"] = this.release[this.type][this.edition.toLowerCase()]["wurl8"]

        this.v2p.dw11.version = this.release[this.type][this.edition.toLowerCase()]["version11"]
        this.v2p.dw11.changeLog = 'https://github.com/dragonwell-project/dragonwell11/wiki/Alibaba-Dragonwell-11-' + this.edition + '-Edition-Release-Notes'
        this.va2d.dw11.x86_64["linux"] = this.release[this.type][this.edition.toLowerCase()]["xurl11"]
        this.va2d.dw11.aarch64["linux"] = this.release[this.type][this.edition.toLowerCase()]["aurl11"]
        this.va2d.dw11.x86_64["alpine-linux"] = this.release[this.type][this.edition.toLowerCase()]["apurl11"]
        this.va2d.dw11.x86_64["windows"] = this.release[this.type][this.edition.toLowerCase()]["wurl11"]
        this.va2d.dw11["risc-v"]["linux"] = this.release[this.type][this.edition.toLowerCase()]["rurl11"]
        
        // set standard as default value
        this.v2p.dw17.version = this.release[this.type]["standard"]["version17"]
        this.v2p.dw17.changeLog = 'https://github.com/dragonwell-project/dragonwell17/wiki/Alibaba-Dragonwell-17-Standard-Edition-Release-Notes'
        this.va2d.dw17.x86_64["linux"] = this.release[this.type]["standard"]["xurl17"]
        this.va2d.dw17.aarch64["linux"] = this.release[this.type]["standard"]["aurl17"]
        this.va2d.dw17.x86_64["alpine-linux"] = this.release[this.type]["standard"]["apurl17"]
        this.va2d.dw17.x86_64["windows"] = this.release[this.type]["standard"]["wurl17"]

        this.v2p.dw21.version = this.release[this.type][this.edition.toLowerCase()]["version21"]
        this.v2p.dw21.changeLog = 'https://github.com/dragonwell-project/dragonwell21/wiki/Alibaba-Dragonwell-21-' + this.edition + '-Edition-Release-Notes'
        this.va2d.dw21.x86_64["linux"] = this.release[this.type][this.edition.toLowerCase()]["xurl21"]
        this.va2d.dw21.aarch64["linux"] = this.release[this.type][this.edition.toLowerCase()]["aurl21"]
        this.va2d.dw21.x86_64["alpine-linux"] = this.release[this.type][this.edition.toLowerCase()]["apurl21"]
        this.va2d.dw21.x86_64["windows"] = this.release[this.type][this.edition.toLowerCase()]["wurl21"]
      });
    }
  },
  watch: {
    edition: {
      handler() {
        let list = []
        // case1
        if (this.edition === 'Extended') {
          list = this.versionItemsOrigin.filter((item)=> item.value !== 'dw17')
          this.version = (this.version === 'dw17') ? 'dw8' : this.version // 设置互斥时，默认值
           // case2
          if (this.version === 'dw11') {
            this.archItems = this.archItemsOrigin.concat([{ text: 'risc-v', value: 'risc-v' }])
          }
        } else {
          list = this.versionItemsOrigin
          // case2
          if (this.version === 'dw11') {
            this.arch = (this.arch === "risc-v") ? "x86_64" : this.arch // 设置默认值
            this.archItems = this.archItemsOrigin // 设置下拉选项数据源
          }
        }
        this.versionItems = list


      }
    },
    version: {
      handler() {
        let list = []
        // case1
        if (this.version === "dw8" || this.arch === "aarch64") {
          list = this.osItemsOrigin.filter((item)=> item.value !== 'alpine-linux')
          this.os = (this.os === 'alpine-linux') ? 'linux' : this.os // 设置互斥时，默认值
        } else {
          list = this.osItemsOrigin
        }
        // case2
        if (this.arch !== "x86_64") {
          list = list.filter((item)=> item.value !== 'windows')
          this.os = (this.os === 'windows') ? 'linux' : this.os // 设置互斥时，默认值
        }
        this.osItems = list

        // case3
        if (this.edition === 'Extended' && this.version === "dw11") {
          this.arch = "x86_64" // 设置默认值
          this.archItems = this.archItemsOrigin.concat([{ text: 'risc-v', value: 'risc-v' }])
        } else {
          this.arch = "x86_64" // 设置默认值
          this.archItems = this.archItemsOrigin // 设置下拉选项数据源
        }
        
      }
    },
    arch: {
      handler() {
        let list = []
        // case1
        if (this.version === "dw8" || this.arch === "aarch64" || this.arch === "risc-v") {
          list = this.osItemsOrigin.filter((item)=> item.value !== 'alpine-linux')
          this.os = (this.os === 'alpine-linux') ? 'linux' : this.os // 设置互斥时，默认值
        } else {
          list = this.osItemsOrigin
        }
        // case2
        if (this.arch !== "x86_64") {
          list = list.filter((item)=> item.value !== 'windows')
          this.os = (this.os === 'windows') ? 'linux' : this.os // 设置互斥时，默认值
        }
        this.osItems = list
      }
    },
  },
  mounted() {
    // 根据初始化数据，设置互斥关系
    let list = []
    // case1
    if (this.edition === 'Extended') {
      list = this.versionItemsOrigin.filter((item)=> item.value !== 'dw17')
      this.version = (this.version === 'dw17') ? 'dw8' : this.version // 设置互斥时，默认值
    } else {
      list = this.versionItemsOrigin
    }
    this.versionItems = list

    // 根据初始化数据，设置互斥关系
    let osItemsList = []
    // case1
    if (this.alpineD) {
      osItemsList = this.osItemsOrigin.filter((item)=> item.value !== 'alpine-linux')
      this.os = (this.os === 'alpine-linux') ? 'linux' : this.os // 设置互斥时，默认值
    } else {
      osItemsList = this.osItemsOrigin
    }
    // case2
    if (this.windowsD) {
      osItemsList = osItemsList.filter((item)=> item.value !== 'windows')
      this.os = (this.os === 'windows') ? 'linux' : this.os // 设置互斥时，默认值
    }
    this.osItems = osItemsList

    axios.get("/addPV.json");
    // step1: 初始请求一次。
    this.getReleasesData()

    // step2: 初始1分钟内，每t秒轮询。
    let count = 0, t = 3
    this.timer1 = setInterval(() => {
      count = count + t
      this.getReleasesData()
      if (count >= 60) {
        this.timer1 && clearInterval(this.timer1);
      }
    }, 1000 * t);

    // step3: 初始1分钟以后，每60秒轮询。
    this.timer2 = setInterval(() => {
      this.getReleasesData()
    }, 1000 * 60);
  },
  destroyed() {
    this.timer1 && clearInterval(this.timer1);
    this.timer2 && clearInterval(this.timer2);
  }
};
</script>

<style>
#app {
  background-color: var(--v-background-base);
  font-family: firasansregular;
}

.v-application code {
  background-color: unset !important;
  color: #7eb6f6 !important;
  box-shadow: unset !important;
  display: unset !important;
  font-size: unset !important;
  font-weight: unset !important;
}

pre {
  padding-right: 1em !important;
}

.select-group-item {
  width: 198px;
  margin: 0px 8px;
}
/* 覆盖原组件样式 */
.select-group-item .v-text-field--outlined > .v-input__control > .v-input__slot {
  min-height: 40px;
}
.select-group-item .v-text-field--outlined > .v-input__control > .v-input__slot > .v-select__slot > .v-input__append-inner {
  margin-top: 8px;
}

.edition-icon-divider {
  display: flex;
  align-items: flex-start;
}
.icon-img {
  margin-top: 4px;
  margin-right: 12px;
}

.font-router-link:hover {
  color: #1890ff;
  cursor: pointer;
  opacity: 0.9;
}
.tck-affidavit {
  /* text-decoration: none; */
  color: #000;
  font-size: 18px;
  font-weight: 400;
}

.footer {
  background-color: #353f4c;
  color: white;
}

.footer .link {
  display: block;
  margin-right: 24px;
  margin-bottom: 10px;
  color: #b9b9b9;
  font-size: 14px;
  text-decoration: none;
}
</style>
